import React from "react";
import { TableContainer, Table } from "@mui/material";
import { ListHead } from "../list";
import StationRow from "./StationRow.component";
import TableContent from "../TableContent.component";

const StationsTableComponent = (props) => {
  const {
    handleRowEditClick = () => { },
    handleRowDeleteClick = () => { },
  } = props

  return (
    <TableContainer>
      <Table>
        <ListHead {...props} />

        <TableContent {...props}
        >
          {(item) => (
            <StationRow
              key={item?.stationId}
              {...props}
              onEditClick={() => handleRowEditClick(item)}
              onDeleteClick={() => handleRowDeleteClick({ station_id: item?.stationId })}
              item={{
                ...item,
              }}
            />
          )}
        </TableContent>
      </Table>
    </TableContainer>
  );
};

export default StationsTableComponent;
